<ng-template cellTemplate let-dataItem="dataItem">
    {{(dataItem | property: field) || (showPlaceholderForCell ? (getPlaceholder(dataItem) | translate) : '')}}
</ng-template>
<ng-template editTemplate
             let-dataItem="dataItem"
             let-columnIndex="columnIndex"
             let-rowIndex="rowIndex"
             let-column="column"
             let-formGroup="formGroup"
             let-isNew="isNew">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <fui-text-control #editControl [attr.id]="elementId"
                      [control]="formGroup.get(column.field)"
                      [formControl]="formGroup.get(column.field)"
                      (valueChange)="controlValueChange($event, dataItem, formGroup)"
                      (focussed$)="columnFocusHandler(columnIndex)"
                      [readOnly]="cellDisabled(formGroup, dataItem)"
                      [placeholder]="getPlaceholder(dataItem)">
    </fui-text-control>
</ng-template>
